import { render, staticRenderFns } from "./ProfileDashboard.vue?vue&type=template&id=97abce96&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ProfileDashboard.vue?vue&type=script&lang=js&"
export * from "./ProfileDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDashboard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProfileDashboard.vue?vue&type=style&index=1&id=97abce96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97abce96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
